import React from 'react';

export const ThinkingState: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden transition-opacity duration-500 rounded-2xl">
      <style>
        {`
          @keyframes thinking-orb-1 {
            0%, 100% { transform: translate3d(0%, 0%, 0) scale(1); }
            33% { transform: translate3d(40%, -40%, 0) scale(1.4); }
            66% { transform: translate3d(-30%, 40%, 0) scale(0.9); }
          }
          @keyframes thinking-orb-2 {
            0%, 100% { transform: translate3d(0%, 0%, 0) scale(1); }
            33% { transform: translate3d(-40%, 40%, 0) scale(1.5); }
            66% { transform: translate3d(40%, -30%, 0) scale(0.9); }
          }
          @keyframes thinking-orb-3 {
            0%, 100% { transform: translate3d(0%, 0%, 0) scale(1); }
            33% { transform: translate3d(40%, 40%, 0) scale(1.4); }
            66% { transform: translate3d(-40%, -40%, 0) scale(1.1); }
          }
          @keyframes thinking-orb-4 {
            0%, 100% { transform: translate3d(0%, 0%, 0) scale(1); }
            33% { transform: translate3d(-40%, -40%, 0) scale(1.6); }
            66% { transform: translate3d(40%, 30%, 0) scale(0.9); }
          }
          .orb-anim-1 { animation: thinking-orb-1 6s infinite ease-in-out; will-change: transform; }
          .orb-anim-2 { animation: thinking-orb-2 8s infinite ease-in-out; will-change: transform; }
          .orb-anim-3 { animation: thinking-orb-3 9s infinite ease-in-out; will-change: transform; }
          .orb-anim-4 { animation: thinking-orb-4 10s infinite ease-in-out; will-change: transform; }
        `}
      </style>

      <div className="absolute inset-0 opacity-40 mix-blend-screen">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-blue-600 rounded-full blur-[100px] orb-anim-1" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-purple-600 rounded-full blur-[120px] orb-anim-2" />
        <div className="absolute top-[20%] right-[-10%] w-[50%] h-[50%] bg-amber-600 rounded-full blur-[100px] orb-anim-3" />
        <div className="absolute bottom-[10%] left-[-10%] w-[50%] h-[50%] bg-emerald-600 rounded-full blur-[120px] orb-anim-4" />
      </div>
    </div>
  );
};
